// extracted by mini-css-extract-plugin
export default {"resultRowWrapper":"ResultRowWrapper_resultRowWrapper__R20Hh","isSelected":"ResultRowWrapper_isSelected__HFHhy","mouseActive":"ResultRowWrapper_mouseActive__NqG2h"};